import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_WEATHER_PARAMS } from "./constants";
import { TFetchedWeatherData } from "./types";

export interface WeatherState {
  weather: TFetchedWeatherData;
}

const initialState: WeatherState = {
  weather: DEFAULT_WEATHER_PARAMS as TFetchedWeatherData,
};

const weatherSlice = createSlice({
  name: "weather",
  initialState,
  reducers: {
    setWeatherData(state, action: PayloadAction<TFetchedWeatherData>) {
      state.weather = action.payload;
    },
  },
});

export const { setWeatherData } = weatherSlice.actions;
export default weatherSlice.reducer;
